<template>
    <dropdown
        :position="position"
        :icon="['far', 'smile']"
        class="has-emoji"
        @shown="show"
        @hidden="hide"
    >
        <div class="picker-loader">
            <basic-loader center aria-label="Picker" />
        </div>

        <div v-if="isVisible">
            <picker-emoji
                :data="index"
                :set="activeSet"
                :native="true"
                :emoji="emoji"
                :emojiTooltip="true"
                :title="title"
                :emojiSize="20"
                :showPreview="false"
                @select="select"
            />
        </div>
    </dropdown>
</template>

<script>
import data from '../vue/picker/all';
import { Picker as PickerEmoji, EmojiIndex } from 'emoji-mart-vue-fast/src';
import 'emoji-mart-vue-fast/css/emoji-mart.css';

const index = new EmojiIndex(data);

export default {
    emits: ['select'],

    components: {
        PickerEmoji,
    },
    props: {
        position: {
            type: String,
            default: 'top-left',
        },
    },
    data() {
        return {
            index: index,
            activeSet: 'native',
            emoji: 'point_up',
            title: 'Pick your emoji…',
            isVisible: false,
            emojisOutput: '',
        };
    },

    computed: {
        native() {
            return this.activeSet === 'native';
        },
    },

    methods: {
        select(emoji) {
            this.emojisOutput = this.emojisOutput + emoji.native;

            this.$emit('select', emoji);
        },

        show() {
            setTimeout(() => {
                this.isVisible = true;
            }, 1000);
        },

        hide() {
            this.isVisible = false;
        },
    },
};
</script>
